import { factory as initTrackWidget } from '../../components/TrackingWidget/TrackWidgetModal.vue';
import { factory as initMobileHeaderMenu } from '../../components/MobileHeaderMenu/MobileHeaderMenu.vue';
import URL from '../../helpers/url';
import { factory as personalAccountButtonFactory } from '../../components/PersonalAccountChoiceModal/PersonalAccountButton.vue';
import initApplicationGlobal from '../Global/Global';

export default function initTrackingPage(eventHub) {
  document.body.classList.add('tracking-page');
  initApplicationGlobal(eventHub);

  initTrackWidget({
    isModal: false,
    initialTrackNumber: (new URL(window.location.href)).searchParam('id') || '',
    el: '#formbar-tracking-popup',
  });

  initMobileHeaderMenu({
    subpage: true,
    subMenuFindTrack: false,
  });

  personalAccountButtonFactory({
    classModifier: 'button-accounts_header-desktop',
    restorePopupMode: 'desktop',
  });
}
